import { render, staticRenderFns } from "./EditorPanel.vue?vue&type=template&id=fc6165c8&"
import script from "./EditorPanel.vue?vue&type=script&lang=js&"
export * from "./EditorPanel.vue?vue&type=script&lang=js&"
import style0 from "./EditorPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports